import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { useMemo } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import { useSSRSafeId } from './ssr';
import TabContext from './TabContext';
import SelectableContext from './SelectableContext';
import TabPanel from './TabPanel';
import { jsx as _jsx } from "react/jsx-runtime";
var Tabs = function Tabs(props) {
  var userId = props.id,
    generateCustomChildId = props.generateChildId,
    propsOnSelect = props.onSelect,
    propsActiveKey = props.activeKey,
    defaultActiveKey = props.defaultActiveKey,
    transition = props.transition,
    mountOnEnter = props.mountOnEnter,
    unmountOnExit = props.unmountOnExit,
    children = props.children;
  var _useUncontrolledProp = useUncontrolledProp(propsActiveKey, defaultActiveKey, propsOnSelect),
    _useUncontrolledProp2 = _slicedToArray(_useUncontrolledProp, 2),
    activeKey = _useUncontrolledProp2[0],
    onSelect = _useUncontrolledProp2[1];
  var id = useSSRSafeId(userId);
  var generateChildId = useMemo(function () {
    return generateCustomChildId || function (key, type) {
      return id ? "".concat(id, "-").concat(type, "-").concat(key) : null;
    };
  }, [id, generateCustomChildId]);
  var tabContext = useMemo(function () {
    return {
      onSelect: onSelect,
      activeKey: activeKey,
      transition: transition,
      mountOnEnter: mountOnEnter || false,
      unmountOnExit: unmountOnExit || false,
      getControlledId: function getControlledId(key) {
        return generateChildId(key, 'tabpane');
      },
      getControllerId: function getControllerId(key) {
        return generateChildId(key, 'tab');
      }
    };
  }, [onSelect, activeKey, transition, mountOnEnter, unmountOnExit, generateChildId]);
  return /*#__PURE__*/_jsx(TabContext.Provider, {
    value: tabContext,
    children: /*#__PURE__*/_jsx(SelectableContext.Provider, {
      value: onSelect || null,
      children: children
    })
  });
};
Tabs.Panel = TabPanel;
export default Tabs;